$(function () {

	var sm = 768;
	var md = 992;
	var lg = 1200;

	$("div.row-stretch-xs").each(function () {
		applyHeightToChildDivs($(this));
	});

	if (breakpoint(sm)) {
		$("div.row-stretch-sm").each(function () {
			applyHeightToChildDivs($(this));
		});
	}

	if (breakpoint(md)) {
		stretchContainer();
		$("div.row-stretch-md").each(function () {
			applyHeightToChildDivs($(this));
		});
	}

	if (breakpoint(lg)) {
		stretchContainer();
		$("div.row-stretch-lg").each(function () {
			applyHeightToChildDivs($(this));
		});
	}

	//Set height of cols w/in rows so that they match
	function applyHeightToChildDivs(jRow) {
		if (jRow.hasClass("row-extended")) { return false; }
		var jCols = jRow.find("> div").not('.no-stretch');
		jCols.css({ height: jRow.height() + "px" });
	}


	//make sure that main content takes up viewport height
	function stretchContainer() {
		var jContainer = $("div.main > div.container");
		var nWindowHeight = $(window).height();
		var nContainerHeight = jContainer.height();
		if (nWindowHeight > nContainerHeight) {
			var jLastRow = jContainer.find("> div.row-extend");
			//console.log(jLastRow);
			var nTargetHeight = (nWindowHeight - nContainerHeight) + jLastRow.height();
			jLastRow
				.height(nTargetHeight - 1)
				.addClass("row-extended");
		}
	}

	function breakpoint(desiredWidth) {
		return window.innerWidth >= desiredWidth;
	}
});